import { TGetMyProfileData } from "@elixir/types";
import { GET_AXON_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function getMyProfile(): Promise<TGetMyProfileData> {
  const AXON_HOST = GET_AXON_HOST();
  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    credentials: "include",
    mode: "cors",
  };
  const response = await fetch(
    `${AXON_HOST}/doctor-profile/get-my-profile`,
    requestOptions
  );
  const { success, data } = await response.json();
  if (success) return data;

  return {} as TGetMyProfileData;
}
